import { virtualDir } from "#skyward_global";
import { showInformationDialog } from "#skyward_modalLayer"
import { registerEvents } from "./skyward.ui.events";
import { notifyDOMLoad, submitForm } from "#skyward_window";
import { getValue } from "./skyward.ui.controls";

$(function ()
{
    $(document.body).on("keydown.altF6Listener", function (event)
    {
        if (!event.altKey || event.which !== 117)
        {
            return;
        }

        if ($(".f6AuditContent").length <= 0)
        {
            const data = {
                routeHash: $('#RouteHash').val(),
                dovPrimaryID: $('.dataObjectViewer:not(.detailsPanel .dataObjectViewer)')?.data('primaryid'),
                dovPrimaryIDHash: $('.dataObjectViewer:not(.detailsPanel .dataObjectViewer')?.data('primaryidhash')
            }

            const deferred = $.post(virtualDir + 'SkySys/F6Audit/GetF6Audit?renderType=contentOnly', data, null, "viewparthtml");

            deferred.done(function (htmlResults)
            {
                if (htmlResults)
                {
                    showInformationDialog("Audit Information", htmlResults);
                }
            });
        }
    });
});

const events =
{
    "exportF6Audit": exportF6Audit,
    "loadF6Audit": loadF6Audit
};

registerEvents("f6AuditWindow", events);

function loadF6Audit (this: HTMLElement | JQuery<HTMLElement>)
{
    const auditSubmitDiv = $(this).closest('.auditSubmitDiv');
    const data =
    {
        objectID: getValue($('#AuditObjectID')),
        id: $('#F6AuditID')?.val(),
        auditObjectIDHash: $('#AuditObjectIDHash')?.val(),
        f6AuditIDHash: $('#F6AuditIDHash')?.val(),
    }
    const deferred = $.post(virtualDir + 'SkySys/F6Audit/LoadF6Audit/', data, null, "viewparthtml");

    deferred.done(function (htmlResults)
    {
        const auditContent = auditSubmitDiv.siblings(".f6AuditContent");
        if (htmlResults)
        {
            auditContent.html(htmlResults);
            notifyDOMLoad(auditContent);
        }
        else
        {
            auditContent.html('');
        }
    });
}

function exportF6Audit (this: HTMLElement | JQuery<HTMLElement>)
{
    const exportButton = $(this);

    
    const url = virtualDir + "SkySys/F6Audit/ExportData";

    var data = {
        fileName: exportButton.data("filename"),
        isBase: exportButton.data("isbase"),
        objectID: getValue($('#AuditObjectID')),
        id: getValue($('#F6AuditID')),
        auditObjectIDHash: getValue($('#AuditObjectIDHash')),
        f6AuditIDHash: getValue($('#F6AuditIDHash'))
    }
    submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
}